var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-card',[_c('v-card-text',{staticClass:"pt-0"},[_c('div',{staticClass:"text-h6 font-weight-light mb-2"},[_vm._v("Related Queries")]),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.queries}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }